const CATEGORY_INFIX = 'c';
const EDITO_INFIX = 'e';
const PRODUCT_INFIX = 'p';
const STATIC_INFIX = 's';
const SEARCH_INFIX = 'q';
export { CATEGORY_INFIX, EDITO_INFIX, PRODUCT_INFIX, STATIC_INFIX, SEARCH_INFIX };